var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"processStepSection"},[_c('SyncLoader',{attrs:{"loading":true,"color":"#3597fa","height":"24px","width":"24px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }